var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"character-contain"},[_c('p',{staticClass:"title"},[_vm._v("单字「"+_vm._s(_vm.target.title)+"」")]),_c('p',{staticClass:"caption"},[_vm._v(_vm._s(_vm.target.caption))])])}
var staticRenderFns = []

export { render, staticRenderFns }